import { render, staticRenderFns } from "./imageLinkCellRenderer.vue?vue&type=template&id=0b61f4c5&scoped=true"
import script from "./imageLinkCellRenderer.ts?vue&type=script&lang=ts&external"
export * from "./imageLinkCellRenderer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61f4c5",
  null
  
)

export default component.exports